export const TranslocoStateConst: {scope: string; alias: string}[] = [
  { scope: 'generic-wrapper', alias: 'GENERIC_WRAPPER'}
];
